<template>
  <with-actions>
    <organization-form :organization="organization"></organization-form>
    <div class="row" v-if="can('write_organizations')">
      <div class="col-md-2 text-right"></div>
      <div class="col-md-8">
        <button class="btn btn-success btn-lg" @click="save($event)">Create</button>
      </div>
    </div>
  </with-actions>
</template>
<script>
import _ from 'lodash';
import Vue from 'vue';
import Api from '@/store/jsonapi';
import Alerts, { handle } from '@/utils/alerts';

export default {
  data: function () {
    return {
      organization: {
        name: '',
        vat_no: '',
        country_code: 'DK',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
        accounting_adapter: '',
        tos_url: '',
        global_attrs: [],
        logo: '',
        is_managed: true,
        ssl_certificate_frontend: '',
        ssl_certificate_api: '',
        domain_name: ''
      }
    };
  },
  methods: {
    save: handle(async function () {
      await Api.create('organizations', this.organization);
      this.$router.push({ name: 'organizations' });
    })
  }
};
</script>
